<template>
    <div>
        <footer>
            <div class="container">
                <div class="footer-content">
                    <div class="footer-details">
                        <div class="footer-contact">
                            <span>Contact:</span>
                            <a class="link" :href="`tel:${$globalConfig.contacts.phone}`">
                                {{ $globalConfig.contacts.phone }}
                            </a>
                            <a :href="`mailto:${$globalConfig.contacts.email}`">
                                {{ $globalConfig.contacts.email }}
                            </a>
                            <p>
                                {{ $globalConfig.contacts.address }}
                            </p>
                            <!--<div class="stay-connected">
                                <p>Let’s stay connected</p>
                                <div class="social-links">
                                    <a href="#">
                                        <img class="fb-link" src="../assets/svgs/003-facebook.svg" />
                                    </a>
                                    <a href="#">
                                        <img class="linkedin" src="../assets/svgs/linkedin.svg" />
                                    </a>
                                    <a href="#">
                                        <img class="insta-link" src="../assets/svgs/instagram.svg" />
                                    </a>
                                </div>
                            </div>-->
                        </div>
                        <div class="footer-description">
                            <div class="we-accept">
                                <p>WE ACCEPT</p>
                                <img src="../assets/images/cards-logo.png" alt="We accept">
                            </div>
                        </div>
                    </div>
                    <div class="reserved-rights">
                        <p>© Skies Are Business. All rights reserved.</p>
                        <a href="/terms.html">Privacy Policy Terms & Conditions</a>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
/* eslint-disable */

export default {
    name: 'FooterSection',
}
</script>

<style lang="scss" scoped>
footer {
    background-color: #000041;
    padding: 40px 0 0px;
    color: #bfbfbf;
    font-size: 12px;

    .container {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
        max-width: 1140px;
        position: relative;

        .footer-content {
            width: 100%;
            display: flex;
            flex-direction: column;
            position: relative;

            .footer-details {
                display: flex;
                justify-content: space-between;
                font-family: 'Poppins-Regular', sans-serif;
                font-size: 14px;
                margin-top: 10px;

                .footer-contact {
                    width: 55%;
                    display: flex;
                    flex-direction: column;

                    span {
                        font-family: 'Poppins-Bold', sans-serif;
                        font-size: 18px;
                        line-height: 27px;
                        color: #ffffff;
                        text-align: left;
                        letter-spacing: 0;
                        margin-bottom: 30px;
                    }

                    a {
                        text-decoration: none;
                        color: #bfbfbf;

                        &:focus {
                            outline: none;
                        }

                        &:hover {
                            color: #ebe0e0;
                        }
                    }

                    .link {
                        margin-bottom: 5px;
                    }

                    .stay-connected {
                        display: flex;
                        p {
                            font-family: 'Poppins-Medium', sans-serif;
                            font-size: 16px;
                            line-height: 25px;
                            color: #ffffff;
                        }

                        img {
                            padding-left: 10px;
                            padding-top: 15px;
                            width: 20.5px;
                        }

                        .linkedin {
                            width: 30px;
                        }
                        .insta-link {
                            width: 30px;
                        }
                    }
                }

                .footer-description {
                    width: 40%;
                    font-size: 12px;

                    .we-accept {
                        text-align: center;

                        img {
                            width: 300px;
                        }

                        @media screen and (max-width: 768px) {
                            img {
                                width: 80%;
                            }
                        }
                    }
                }
            }

            .reserved-rights {
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: 'Poppins-Regular', sans-serif;
                font-size: 12px;
                color: #707070;

                p {
                    padding-right: 10px;
                }

                a {
                    text-decoration: none;
                    color: #707070;

                    &:focus {
                        outline: none;
                    }

                    &:hover {
                        color: #bfbfbf;
                    }
                }
            }
        }

        @media (max-width: 768px) {
            max-width: 540px;
            padding: 0 30px;
            .footer-content {
                .footer-details {
                    flex-direction: column-reverse;

                    .footer-contact {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        padding-bottom: 10px;

                        span {
                            text-align: center;
                        }

                        a {
                            align-self: center;
                        }

                        p {
                            align-self: center;
                            text-align: center;
                        }

                        .stay-connected {
                            align-self: center;
                            align-items: center;

                            .social-links {
                                img {
                                    padding-top: 0;
                                }
                            }
                        }
                    }

                    .footer-description {
                        width: 100%;
                    }
                }
            }

            .reserved-rights {
                flex-direction: column;
                padding-bottom: 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterSection.vue